const range = (n, base) => Array.from({ length: n }, (_, i) => `${base}/p${String(i + 1).padStart(2, "0")}.jpg?v=2`);

export const CATALOGS = [
  {
    id: "pvc",
    tag: { it: "Sistemi in PVC", en: "PVC systems" },
    title: { it: "Sistemi per porte e finestre in PVC", en: "PVC door and window systems" },
    desc: {
      it: "Sistemi in PVC ad alte prestazioni, progettati per offrire comfort, isolamento, durabilità e una raffinata espressione architettonica.",
      en: "High-performance PVC systems designed for comfort, insulation, durability and refined architectural expression.",
    },
    pdf: "/cataloghi/HGW_Catalogo_PVC.pdf?v=2",
    size: "3,5 MB",
    pages: range(19, "/cataloghi/pvc"),
    hd: range(19, "/cataloghi/pvc-hd"),
    mini: range(19, "/cataloghi/pvc-mini"),
  },
  {
    id: "pergole",
    tag: { it: "Sistemi architettonici per esterni", en: "Outdoor architectural systems" },
    title: { it: "Pergole e sistemi per esterni", en: "Pergolas and outdoor systems" },
    desc: {
      it: "Pergole bioclimatiche, sistemi di copertura, coperture vetrate retrattili e fisse, sistemi vetrati e di protezione per esterni.",
      en: "Bioclimatic pergolas, covering systems, retractable and fixed glass roofs, glazing and outdoor protection systems.",
    },
    pdf: "/cataloghi/HGW_Catalogo_Pergole.pdf?v=2",
    size: "10 MB",
    pages: range(32, "/cataloghi/pergole"),
    hd: range(32, "/cataloghi/pergole-hd"),
    mini: range(32, "/cataloghi/pergole-mini"),
  },
];
